import React from "react";

export default function Tab(props) {
  const { children, shape, separatorPosition, separator, dataCy } = props;
  let className = "Tab " + shape;
  function handleTabClick() {
    props.setSelectedIndex(props.tabIndex);
  }
  if (props.isSelected) {
    className += " selected";
  }
  return (
    <>
      {separatorPosition === "before" && separator}
      <div className={className} onClick={handleTabClick} data-cy={dataCy}>
        {children}
      </div>
      {separatorPosition === "after" && separator}
    </>
  );
}
